<form [formGroup]="processForm" max-width-form-web margin-auto *ngIf="!loading">
  <ion-grid>
    <ion-row class="ion-align-items-center ion-justify-content-center">
      <!-- form -->
      <ion-col size="12">
        <ion-label color="primary-dark" position="stacked">
          {{ 'COMPONENTS.FORMS.SURVEY_TYPE' | translate }}
        </ion-label>
        <ion-select
          interface="alert"
          cancelText="{{ 'COMPONENTS.FORMS.CANCEL' | translate }}"
          doneText="Selecionar"
          placeholder="{{ 'COMPONENTS.FORMS.CHOOSE_ONE' | translate }}"
          formControlName="procedureId"
        >
          <ion-select-option *ngFor="let procedure of procedures.data" [value]="procedure">
            {{ procedure.procedureName }}
          </ion-select-option>
        </ion-select>

        <ion-note *ngIf="procedureId.dirty && procedureId.errors?.required" color="danger">
          {{ 'COMPONENTS.FORMS.INFORM_THE_TYPE_SURVEY' | translate }}
        </ion-note>
      </ion-col>

      <ion-col size="12">
        <ion-label color="primary-dark" position="stacked">
          {{ 'COMPONENTS.FORMS.DESCRIPTION' | translate }}
        </ion-label>
        <ion-textarea
          formControlName="userProcedureDescription"
          class="padding-right-2x"
          type="text"
          placeholder="{{ 'COMPONENTS.FORMS.ENTER_THE_DESCRIPTION_' | translate }}"
          width-100
          rows="5"
          maxlength="3000"
          rows="4"
        >
        </ion-textarea>
        <div class="length-text"> {{ this.userProcedureDescription?.value?.length }} / 3000</div>
        <ion-note
          *ngIf="userProcedureDescription.dirty && userProcedureDescription.errors?.required"
          color="danger"
        >
          {{ 'COMPONENTS.FORMS.ENTER_THE_DESCRIPTION' | translate }}
        </ion-note>
      </ion-col>
      <ion-col size="12" class="ion-no-padding ion-margin-top ion-hide-md-up">
        <ion-button *ngIf="showButton" expand="block" color="buttonPrimary" (click)="submit(processForm)">
          {{ 'COMPONENTS.FORMS.SAVE' | translate }}
        </ion-button>
      </ion-col>
      <ion-row
        class="ion-align-items-center ion-padding-horizontal ion-justify-content-end ion-hide-md-down"
        width-100
      >
        <ion-col size="12" class="ion-no-padding ion-margin-top ion-text-end">
          <ion-button *ngIf="showButton" color="primary" (click)="submit(processForm)" width-300>
            {{ 'COMPONENTS.FORMS.SAVE' | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-row>
  </ion-grid>
</form>
